<template>
  <core-template-default v-if="!this.$route.meta.independente" :style="`
  --theme-primary: ${$vuetify.theme.themes.light.primary};
  --theme-secondary: ${$vuetify.theme.themes.light.secondary};
  --theme-tertiary: ${$vuetify.theme.themes.light.tertiary};
  `"/>
  <v-app v-else :style="`
  --theme-primary: ${$vuetify.theme.themes.light.primary};
  --theme-secondary: ${$vuetify.theme.themes.light.secondary};
  --theme-tertiary: ${$vuetify.theme.themes.light.tertiary};
  `">
    <notificacao/>
    <loading/>
    <router-view/>
  </v-app>
</template>

<script>
import Loading from '@/views/components/Loading'
import {mutationTypes} from '@/core/constants'
import Notificacao from '@/views/components/Notificacao'
import CoreTemplateDefault from '@/views/components/core/TemplateDefault.vue'

export default {
    name: 'RootPage',
    components: {CoreTemplateDefault, Notificacao, Loading},
    data() {
        return {}
    },
    async beforeMount() {
        await this.setarDadosIniciais()
    },
    mounted() {
        this.onResponsiveInverted()
    },
    methods: {
        async setarDadosIniciais() {
            if (this.$store.state.comum.page.requiresAuth) {
                await this.carregarParametros()
                this.carregarTimezone()
            }
        },
        onResponsiveInverted() {
            if (window.innerWidth <= 720) {
                this.$store.commit(mutationTypes.DRAWER.SET_ASIDE_HIDE, false)
            }
        },
        async carregarParametros() {
            await this.configurarParametros()
        },
        carregarTimezone() {
            this.$store.commit(mutationTypes.COMUM.SET_TIMEZONE, this.$store.state.configuracao.parametros.timezone)
        },
    }
}
</script>

<style lang="stylus">
.menu
  width 100%
  height 100%
  display flex
  flex-direction row

.menu-content
  width 100%
  height 100%
  display flex
  flex-direction column

html, body, .application
  font-family 'Open Sans', sans-serif

.pagination
  display flex
  align-items center

.altura-componente-container
  min-height 50vh

.btn-disabled
  pointer-events visible !important
  cursor not-allowed

.erro-inicializacao
  width 100%
  padding 0
  text-align center
  color #555
  height 80vh
  display flex
  justify-content center
  align-items center

  i
    font-size 36px

  p
    font-size 18px
    margin 10px 0 0
    font-weight 600

.actions-form
  padding 0 20px 20px
  margin-top 20px
  justify-content space-between
  display flex
  font-size 13px

  .align-left
    .action-secundary
      padding 10px 15px
      margin-right 10px
      color #555555
      border 1px solid #555555
      border-radius 2px

      &:hover
        color white
        border 1px solid #555555
        background-color #555555

    .action-delete
      padding 10px 15px
      margin-right 10px
      color #cccccc
      border 1px solid #cccccc
      border-radius 2px

      &:hover
        color white
        border 1px solid #a03232
        background-color #a03232

  .align-right
    .action-primary
      padding 10px 15px
      border 1px solid #7aa329
      background-color #7aa329
      color white
      margin-left 10px
      border-radius 2px

      &:hover
        background-color lighten(#7aa329, 10%)
        border 1px solid lighten(#7aa329, 10%)

    .action-secundary
      padding 10px 15px
      margin-left 10px
      color #777777

      &:hover
        color darkred

.form-content
  margin-top 0

  .section-label
    font-size 20px !important
    color #777 !important
    font-weight 400

  .v-text-field
    .v-label
      font-size 20px !important
      color #777 !important
      top -5px
      height 25px

  .az-date
    .v-text-field
      .v-label
        top 0

  .v-input--radio-group__input
    .v-label
      font-size 14px !important
      color #777 !important

  .col
    padding 8px 12px !important

  .v-textarea textarea
    max-height 100px
    overflow-y auto

.v-tooltip__content
  padding 10px
  font-size 12px
  opacity 1 !important
  background #333333 !important
  text-align justify !important
  line-height 1.4

.v-tooltip__content.menuable__content__active
  max-width 500px

.checkbox_rowa
  background-color #90a4ae

@keyframes fade
  from
    opacity 0
    transform scale(0.5)
  to
    opacity 1
    transform scale(1)

@keyframes moveX
  from
    opacity 0
    transform translateX(-35%)
  to
    opacity 1
    transform translateX(0%)

@keyframes moveXRight
  from
    opacity 0
    transform translateX(95%)
  to
    opacity 1
    transform translateX(0%)

@keyframes moveY
  from
    opacity 0
    transform translateY(-35%)
  to
    opacity 1
    transform translateY(0%)

@keyframes moveYBack
  from
    opacity 0
    transform translateY(95%)
  to
    opacity 1
    transform translateY(0%)

.status-cobranca-PAGO
  color #4caf50

.status-cobranca-PARCIALMENTE_PAGO
  color #FF6B35

.status-cobranca-CANCELADA
  color #f44336

.cobranca-vencida
  color #f44336

.label-primary-com-borda
  font-weight bold
  color var(--theme-primary)
  border-bottom 1px solid #e0e0e0

/* largura */
::-webkit-scrollbar
  width 10px

/* trilho */
::-webkit-scrollbar-track
  background #f1f1f1

/* "thumb" */
::-webkit-scrollbar-thumb
  background #888
  border-radius 6px

::-webkit-scrollbar-thumb:hover
  background #555

.table-dense
  thead tr th
    padding 0 8px !important

  tbody tr td
    padding 0 8px !important

.container-tabs
  border-bottom 1px solid #ccc

  .v-tab
    text-transform none !important

  .v-tabs__div
    text-transform none

  .v-tabs__item--active
    font-weight bold
    border-bottom 1px solid white
    border-left 1px solid #ccc
    border-right 1px solid #ccc
    border-top 1px solid #ccc
    border-radius 2px

  .v-tabs__item
    color #777777
    padding 10px 20px

  .v-tabs__slider-wrapper
    display none

  .v-tabs__container
    border-bottom 1px solid #ccc

  .v-text-field__slot
    font-size 14px

  .v-select__selections
    font-size 14px

.hover-primary:hover
  color var(--theme-primary) !important

.text-transform-none
  text-transform none

</style>
